"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProductRelatedQuoteProperty = exports.productRelatedQuotePropertyDefinition = void 0;
exports.productRelatedQuotePropertyDefinition = {
    view: {
        label: 'Product related quote',
        hint: 'ATTENTION: This field should only be updated after aligning with your local Legal and Int. Brand Team. Please be aware of the severe implications the contents of this field might have to local authorities and other associations after being published!',
    },
    constraints: [
        {
            name: 'maxLength',
            argument: 150,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'product-related-quote',
};
const isProductRelatedQuoteProperty = (prop) => {
    return prop.name === exports.productRelatedQuotePropertyDefinition.name;
};
exports.isProductRelatedQuoteProperty = isProductRelatedQuoteProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvZHVjdC1yZWxhdGVkLXF1b3RlLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvcHJvZHVjdC1yZWxhdGVkLXF1b3RlLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEscUNBQXFDLEdBQUc7SUFDbkQsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLHVCQUF1QjtRQUM5QixJQUFJLEVBQUUsNFBBQTRQO0tBQ25RO0lBQ0QsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsV0FBVztZQUNqQixRQUFRLEVBQUUsR0FBRztTQUNkO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsTUFBTTtJQUNaLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLHVCQUF1QjtDQUNFLENBQUE7QUFJMUIsTUFBTSw2QkFBNkIsR0FBRyxDQUFDLElBQWtCLEVBQXVDLEVBQUU7SUFDdkcsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLDZDQUFxQyxDQUFDLElBQUksQ0FBQTtBQUNqRSxDQUFDLENBQUE7QUFGWSxRQUFBLDZCQUE2QixpQ0FFekMifQ==